import type { UsersTranslations } from './types'

/**
 * Urdu translations for Users domain
 */
export const urTranslations: UsersTranslations = {
  // Page/Section level
  title: "صارفین",
  subtitle: "صارفین اور اجازتوں کا انتظام کریں",

  // Actions specific to domain
  addUser: "صارف شامل کریں",
  editUser: "صارف میں ترمیم کریں",
  deleteUser: "صارف حذف کریں",

  // Search and filters
  searchPlaceholder: "صارفین تلاش کریں...",
  noItemsFound: "کوئی صارف نہیں ملا",
  noItemsDescription: "آپ نے ابھی تک کوئی صارف شامل نہیں کیا۔ شروع کرنے کے لیے اپنا پہلا صارف شامل کریں۔",
  addFirst: "اپنا پہلا صارف شامل کریں",

  // Form section
  form: {
    name: "صارف کا نام",
    namePlaceholder: "صارف کا نام درج کریں",
    status: "حالت",

    validation: {
      nameRequired: "صارف کا نام درکار ہے",
    }
  },

  // Status and states specific to domain
  status: {
    active: "فعال",
    inactive: "غیر فعال",
  },

  // Toast messages for domain operations
  messages: {
    createSuccess: "صارف کامیابی سے بنایا گیا",
    updateSuccess: "صارف کامیابی سے اپ ڈیٹ ہوا",
    deleteSuccess: "صارف کامیابی سے حذف ہوا",
    deleteConfirm: "کیا آپ واقعی اس صارف کو حذف کرنا چاہتے ہیں؟",
  },

  // Table headers if applicable
  table: {
    name: "نام",
    status: "حالت",
  },

  // Top-level convenience keys
  name: "نام",
  namePlaceholder: "صارف کا نام درج کریں",
  statusLabel: "حالت",
  nameRequired: "صارف کا نام ضروری ہے",
  active: "فعال",
  inactive: "غیر فعال",
  createSuccess: "صارف کامیابی سے بنایا گیا",
  updateSuccess: "صارف کامیابی سے اپ ڈیٹ ہوا",
  deleteSuccess: "صارف کامیابی سے حذف ہوا",
  deleteConfirm: "کیا آپ واقعی اس صارف کو حذف کرنا چاہتے ہیں؟",

  // Attempt lockout
  unlockAttempts: "اکاؤنٹ کا قفل کھولیں (کوششیں)",
  attemptBlocked: "مقفل (بہت زیادہ کوششیں)",

  // Customer Onboarding (Urdu)
  onboarding: {
    title: 'کسٹمر آن بورڈنگ',
    subtitle: 'موجودہ SAP کسٹمرز کو پورٹل میں رجسٹر کریں',
    modeManual: 'دستی اندراج',
    modeExcel: 'Excel درآمد',
    successMessage: 'کسٹمر کامیابی سے رجسٹر ہوا',
    errorMessage: 'رجسٹریشن ناکام۔ دوبارہ کوشش کریں۔',
    submit: 'کسٹمر رجسٹر کریں',
    submitting: 'رجسٹر ہو رہا ہے...',
    errors: {
      emailRequired: 'ای میل درکار ہے',
      nameRequired: 'کمپنی / پورا نام درکار ہے',
      mobilePhoneRequired: 'موبائل نمبر درکار ہے',
      passwordMin: 'پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے',
      cityRequired: 'شہر درکار ہے',
      countryRequired: 'ملک درکار ہے',
      phoneInvalidFormat: 'موبائل نمبر میں صرف ہندسے اور شروع میں اختیاری + ہو سکتا ہے',
      phoneInvalidLength: 'موبائل نمبر 10 سے 15 ہندسوں کے درمیان ہونا چاہیے',
      vatNumberRequired: 'VAT نمبر درکار ہے',
      crNumberRequired: 'CR نمبر درکار ہے',
      addressLine1Required: 'گلی کا پتہ درکار ہے',
      regionRequired: 'علاقہ درکار ہے',
      postalCodeRequired: 'پوسٹل کوڈ درکار ہے',
      sapCustomerGroupRequired: 'SAP کسٹمر گروپ درکار ہے',
      registerDisabled: 'رجسٹریشن فی الحال بند ہے',
      emailTaken: 'ای میل پہلے سے رجسٹرڈ ہے',
      phoneTaken: 'موبائل نمبر پہلے سے رجسٹرڈ ہے',
      sapBusinessPartnerNumberTaken: 'SAP بزنس پارٹنر نمبر پہلے سے رجسٹرڈ ہے',
      vatCertificateRequired: 'VAT سرٹیفکیٹ درکار ہے (یا SAP بزنس پارٹنر نمبر درج کریں)',
      crDocumentRequired: 'CR دستاویز درکار ہے (یا SAP بزنس پارٹنر نمبر درج کریں)',
    },
    steps: {
      account: 'اکاؤنٹ',
      business: 'کاروبار',
      address: 'پتہ',
    },
    form: {
      nameAndCompany: 'کمپنی / پورا نام',
      nameAndCompanyPlaceholder: 'کمپنی یا پورا نام درج کریں',
      email: 'ای میل',
      emailPlaceholder: 'ای میل درج کریں',
      mobilePhone: 'موبائل نمبر',
      password: 'پاس ورڈ',
      showPassword: 'پاس ورڈ دکھائیں',
      hidePassword: 'پاس ورڈ چھپائیں',
      regeneratePassword: 'دوبارہ بنائیں',
      autoGeneratedBadge: 'خودکار بنایا گیا',
      sapBusinessPartnerNumber: 'SAP پارٹنر نمبر',
      sapCustomerGroup: 'SAP کسٹمر گروپ',
      vatNumber: 'VAT نمبر',
      crNumber: 'CR نمبر',
      addressLine1: 'گلی کا پتہ',
      addressLine1Placeholder: 'گلی کا پتہ درج کریں',
      city: 'شہر',
      region: 'علاقہ',
      regionPlaceholder: 'علاقہ منتخب کریں',
      postalCode: 'پوسٹل کوڈ',
      country: 'ملک',
    },
    excel: {
      dropzone: 'Excel فائل یہاں ڈراپ کریں',
      dropzoneHint: 'SAP برآمد سے .xlsx, .xls فائلیں قبول کرتا ہے',
      browseFile: 'فائل تلاش کریں',
      parseError: 'فائل پڑھنے میں ناکامی۔',
      customersLoaded: 'کسٹمرز لوڈ ہوئے',
      emailsGenerated: 'ای میل بنائے گئے',
      succeeded: 'کامیاب',
      failed: 'ناکام',
      clear: 'صاف کریں',
      registerAll: 'سب رجسٹر کریں',
      retryFailed: 'ناکام دوبارہ کوشش',
      bulkSuccess: '{{count}} کسٹمرز کامیابی سے رجسٹر ہوئے',
      downloadResults: 'نتائج ڈاؤن لوڈ کریں',
      col: {
        sap: 'SAP #',
        name: 'نام',
        email: 'ای میل',
        phone: 'فون',
        city: 'شہر',
        status: 'حالت',
        password: 'پاس ورڈ',
      },
      status: {
        pending: 'انتظار',
        submitting: 'رجسٹر ہو رہا ہے...',
        success: 'کامیاب',
        error: 'ناکام',
      },
    },
  },
}
